import { isDateKey, toDateKey, todayDateKey } from '@features/quote/utils/dateKey';
import { MAX_SERVICE_MILEAGE } from '../schemas/smriqLastCompletedService.schema';
import type { SmriqLastCompletedServiceSelection } from '../types/smriq.types';

export interface DefaultSelectionInput {
    saved: SmriqLastCompletedServiceSelection | null | undefined;
    hasSavedSettings: boolean;
    vehicleLastServiceDate?: string;
    vehicleLastServiceMileage?: number;
    today?: string;
}

const isValidMileage = (value: number | undefined): value is number =>
    typeof value === 'number' && Number.isInteger(value) && value >= 0 && value <= MAX_SERVICE_MILEAGE;

export const defaultLastCompletedServiceSelection = ({
    saved,
    hasSavedSettings,
    vehicleLastServiceDate,
    vehicleLastServiceMileage,
    today = todayDateKey(),
}: DefaultSelectionInput): SmriqLastCompletedServiceSelection | null => {
    if (hasSavedSettings) return saved ?? null;

    const date = toDateKey(vehicleLastServiceDate);
    if (!date || !isDateKey(date) || date > today) return null;
    if (!isValidMileage(vehicleLastServiceMileage)) return null;

    return { mode: 'auto', completed_date: date, completed_mileage: vehicleLastServiceMileage };
};
